import { createPetOwner } from "../../api/petOwnerService";

export const useCreatePetOwner = (successCallback) => {
    const create = async (data) => {
        try {
            const newPetOwner = await createPetOwner(data);
            if (successCallback)
            {
                successCallback(newPetOwner);
            }
            return newPetOwner;
        } catch (error) {
            console.error("Failed to create pet owner:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};